import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Subscription } from 'rxjs';
import { OrganizationService } from '@app/core/services/OrganizationService';
import { FileService } from '@app/core/services/FileService';

export interface ReceivedInvoiceDialogData {
  organizationId: number;
  invoiceId: number;
  invoiceNumber?: string;
  type?: string;
}

@Component({
  selector: 'app-received-invoice-dialog', standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, MatTooltipModule],
  templateUrl: './received-invoice-dialog.component.html',
  styleUrls: ['./received-invoice-dialog.component.scss']
})
export class ReceivedInvoiceDialogComponent implements OnInit, OnDestroy {
  detail: any = null;
  loading = true;
  error = '';
  private request?: Subscription;

  constructor(@Inject(MAT_DIALOG_DATA) public data: ReceivedInvoiceDialogData,
    private organizations: OrganizationService, public files: FileService,
    private cdr: ChangeDetectorRef) {}

  ngOnInit(): void { this.load(); }
  ngOnDestroy(): void { this.request?.unsubscribe(); }
  date(value: string): string { return value ? value.slice(0, 10) : '–'; }

  load(): void {
    this.request?.unsubscribe();
    this.loading = true; this.error = ''; this.detail = null;
    this.request = this.organizations.getReceivedInvoice(this.data.organizationId, this.data.invoiceId).subscribe({
      next: detail => { this.detail = detail; this.loading = false; this.cdr.markForCheck(); },
      error: () => { this.error = 'Underlaget kunde inte hämtas. Försök igen.'; this.loading = false; this.cdr.markForCheck(); }
    });
    this.cdr.markForCheck();
  }
}
